import { createSlice } from '@reduxjs/toolkit';
import formInitValues from '../assets/json/formInitValues.json';

const calcSlice = createSlice({
  name: 'calc',
  initialState: { 
    value: {
      ...formInitValues[1]
    }
  },
  reducers: {
    changeCalc: (state, action) => {
      state.value = { ...action.payload };
    }
  }
});

const { actions, reducer } = calcSlice
export const { changeCalc } = actions;

export const selectCalc = (state) => state.calc.value;

export default reducer;